import React, { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import lottie from "lottie-web";
import success from "../../animation/succesful.json";
import { Button } from "../../common/button";
import * as thirdpartyService from "../../services/thirdpartyService";
import { message} from 'antd';
import { showErrorToast } from "V2.0/utils";

function ThirdPartAuthSuccess(props) {
  const container = useRef(null);

  // Using navigate if needed later, since it's declared
  const navigate = useNavigate();

  useEffect(() => {
    let anim;
    if (container.current) {
      anim = lottie.loadAnimation({
        container: container.current, 
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: success, 
      });
    }

    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get('code') || "";
    const locationParam = queryParams.get('location') || "";
    const accountsServer = queryParams.get('accounts-server') || "";
    const projectId = localStorage.getItem('projectId') || "";
    const type = localStorage.getItem("authCategory") || "";

    /* An OAuth provider that refuses the request redirects back with `error` and no `code`.
       Without this the empty code was still sent to the backend, which failed a round trip
       later with a generic message and lost the provider's own reason. Additive: the success
       path below is untouched. */
    const oauthError = queryParams.get("error") || "";
    const oauthErrorDescription = queryParams.get("error_description") || "";

    if (oauthError) {
      const channel = new BroadcastChannel("oauth");
      channel.postMessage({
        status: "ERROR",
        type,
        reason: oauthErrorDescription || oauthError,
      });
      channel.close();
      window.close();
      return;
    }

    const checkTokenAsync = async () => {
      // OLD: toast-only, no signal back to the opener - fine for a fire-and-forget popup
      // (GHL/Zoho/etc, which never listen for one) but Salesforce's connect flow opens its
      // popup and waits on this "oauth" BroadcastChannel to resolve, so it must be posted here
      // regardless of which provider completed. window.close() is a no-op for a non-popup
      // (directly-navigated) tab, so this is additive for the existing providers.
      // try {
      //   const response= await thirdpartyService.checkToken(projectId, code, locationParam, accountsServer, type);
      //   if(response.status===200)
      //   message.success("Authentication succesful")
      //  } catch (ex) {
      //    if (ex.response && ex.response.status >= 400 && ex.response.status < 500 ) {
      //      message.error(ex.response.data.msg);
      //    }
      //  }
      const channel = new BroadcastChannel("oauth");
      try {
        const response = await thirdpartyService.checkToken(
          projectId,
          code,
          locationParam,
          accountsServer,
          type
        );
        if (response.status === 200)
          channel.postMessage({
            type,
            status: "SUCCESS",
          });
        window.close();
      } catch (ex) {
        showErrorToast(ex, "Failed to Integrate");
        channel.postMessage({
          status: "ERROR",
          type,
        });
        window.close();
      }
    };

    checkTokenAsync();


    return () => {
      if (anim) {
        anim.destroy();
      }
    };
  }, []); //
  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <div ref={container}></div>
      <Button onClick={() => navigate("/")}>Take me home</Button>
    </div>
  );
}

export default ThirdPartAuthSuccess;
